export default "__VITE_ASSET__BLXXyOwt__"